import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ComponentPageTitle } from '../../../page-title/page-title.component';
import { AppServiceService } from '../../../services/app-service.service';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { Subscription } from 'rxjs/Subscription';
import { BusquedaService } from '../../busqueda.service';
import { CreateService } from '../../createservice';
import { CreateCicloComponent } from 'src/app/home/create-ciclo/create-ciclo.component';
import { FiltroPaisService } from '../../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmacionComponent } from '../../confirmacion/confirmacion.component';
import { PasswordnewComponent } from 'src/app/login/passwordnew/passwordnew.component';
import { CreateAgenteComponent } from '../../create-agente/create-agente.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-config-agente',
  templateUrl: './config-agente.component.html',
  styleUrls: ['./config-agente.component.scss']
})
export class ConfigAgenteComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  // campanaColumns: string[] = ['ZONA', 'NOMBRE', 'ROL', 'USUARIO', 'CAP_MAX_AM', 'CAP_MAX_PM', 'CAP_DIS_AM', 'CAP_DIS_PM', 'ACCION'];
  campanaColumns: string[] = ['ZONA', 'NOMBRE', 'ROL', 'USUARIO', 'CAP_MAX_AM', 'CAP_MAX_PM', 'CANT_CITAS_AM', 'CANT_CITAS_PM', 'ACCION'];
  dataSource = new MatTableDataSource<any>([]);
  FILTER: string = '';
  resultsLength: number = 0;
  pageSize = 10;
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  idpais;
  pageEvent: PageEvent;
  public actpage: number = 0;
  provincias: any[] = [];
  provincia: any = { idprovincia: null };
  minDate = new Date();
  fecha = new Date();

  totalmaxcupoAM = 0;
  totalmaxcupoPM = 0;
  totaldispAM = 0;
  totaldispPM = 0;

  constructor(
    private router: Router,
    private snackbar: MatSnackBar,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private spinner: NgxSpinnerService
  ) { }

  @ViewChild('campanapaginator') campanapaginator: MatPaginator;

  ngOnInit() {
    const configuraciondezonas = this.localSave.get('configuraciondezonas');
    this.fecha = configuraciondezonas.fecha;
    if (configuraciondezonas.nivel == 1) {
      this.router.navigate(['home/configprovincia'])
        .then((e) => {
          this.spinner.hide();
        });
    }
    else if (configuraciondezonas.nivel == 2) {
      this.router.navigate(['home/configdistrito'])
        .then((e) => {
          this.spinner.hide();
        });
    }
    else if (configuraciondezonas.nivel == 3) {
      this.router.navigate(['home/configcorregimiento'])
        .then((e) => {
          this.spinner.hide();
        });
    }
    // else if (configuraciondezonas.nivel == 4) {
    //   this.router.navigate(['home/configagente'])
    //     .then((e) => {
    //       this.spinner.hide();
    //     });
    // } 

    const user = this.localSave.get('usuarioPGV');
    // this.getProvincias();

    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = 'Capacidad por';
    // this.loadUsuarios();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarcampana(res.filtro);
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        // console.log(res);
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
  }

  getProvincias() {
    this.gateway.get('getprovincias', {}).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.provincias = aux.rows;
    }
    ).catch(function (e) {
    });
  }

  provinciaSeleccionada(event: any) {
    this.provincia.idprovincia = event.value.idprovincia;
    this.get(0);
  }

  // ============== FILTRO ==============
  selected = 2
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }
  public filtrogeneral() {
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  ngAfterViewInit() {
    // console.log(this.localSave.get('nuevoUserPass'))

    // if (this.localSave.get('nuevoUserPass') == 0) {
    //   setTimeout(() => {
    //     this.openPassword();
    //   })

    // }
  }

  get(page) {
    const configuraciondezonas = this.localSave.get('configuraciondezonas');
    const params = {
      NUM_PAGINA: page,
      FILTRO: this.FILTER,
      NUM_ELEMENTOS: this.pageSize,
      IDPAIS: this.idpais,
      IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU,
      IDPADRE: this.localSave.get('usuarioPGV').IDU,
      IDAREA: this.localSave.get('usuarioPGV').IDAREA,
      ESDISTRIBUIDOR: this.localSave.get('usuarioPGV').esDistribuidor,
      IDCORREGIMIENTO: configuraciondezonas.corregimiento ? configuraciondezonas.corregimiento.id_corregimiento : 0,
      FECHA: this.fecha
    };
    // console.log(params);
    this.spinner.show();
    this.gateway.get('getconfigtecnicoxzona', params).then((result: any) => {
      // console.log(result);
      const zonas = result.rows;
      this.resultsLength = zonas.length;

      // this.totalmaxcupoAM = this.resultsLength ? zonas.map((t: any) => t['cupos_am'] || 0).reduce((acc: number, value: number) => acc + value, 0) : 0;
      // this.totalmaxcupoPM = this.resultsLength ? zonas.map((t: any) => t['cupos_pm'] || 0).reduce((acc: number, value: number) => acc + value, 0) : 0;
      // this.totaldispAM = this.resultsLength ? zonas.map((t: any) => t['cupos_libres_am'] || 0).reduce((acc: number, value: number) => acc + value, 0) : 0;
      // this.totaldispPM = this.resultsLength ? zonas.map((t: any) => t['cupos_libres_pm'] || 0).reduce((acc: number, value: number) => acc + value, 0) : 0;

      this.dataSource = new MatTableDataSource(zonas);
      this.spinner.hide();
    }
    ).catch(function (e) {
      this.spinner.hide();
    });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // this.subscription.unsubscribe();
    // this.subscriptioncreate.unsubscribe();
    // this.subscriptionpais.unsubscribe();
  }

  filtrarcampana(data) {
    this.FILTER = data;
    this.get(0);
  }

  edit(element) {
    //element.idpais = this.idpais;
    const dialogRef = this.dialog.open(CreateAgenteComponent, {
      maxWidth: '130vw',
      width: '900px',
      minHeight: '50vh',
      data: { operacion: 'Editar', agente: element },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.get(this.actpage);
      }
    });
  }

  onRowClick(row: any) {
    // const configuraciondezonas = this.localSave.get('configuraciondezonas');
    // configuraciondezonas['nivel'] = 4;
    // configuraciondezonas['corregimiento'] = row;
    // this.localSave.set('configuraciondezonas', configuraciondezonas);
    // this.router.navigate(['home/configagente'])
    //   .then((e) => {
    //     this.spinner.hide();
    //   });
  }

  volver() {
    const configuraciondezonas = this.localSave.get('configuraciondezonas');
    configuraciondezonas['nivel'] = 3;
    this.localSave.set('configuraciondezonas', configuraciondezonas);
    this.router.navigate(['home/configcorregimiento'])
      .then((e) => {
        this.spinner.hide();
      });
  }

}
